<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="page" :class="{ 'player-view': showPlayerView }">
    <!-- 首页内容 -->
    <template v-if="!showPlayerView">
      <div class="header">
        <img
          src="@/assets/walkman/ic-back.png"
          alt=""
          class="ic-back"
          @click="handleBackClick"
        />

        <div class="header-title">随身听</div>

        <div class="setting" @click="handleSettingClick">
          <img src="@/assets/walkman/ic-setting.png" />
          设置
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <span>{{
            playlistWordList.length > 0 ? currentWordIndex + 1 : 1
          }}</span
          >/{{ totalWordCount || playlistWordList.length || 30 }}
        </div>

        <!-- 空状态：数据没加载出来时显示（包括加载中） -->
        <div class="empty-state" v-if="playlistWordList.length === 0">
          <img src="@/assets/empty.png" alt="空状态" />
        </div>

        <div
          class="word-content"
          v-if="playlistWordList.length > 0 && currentWord"
        >
          <div class="word" :style="{ fontSize: wordFontSize }">
            <span class="word-text">
              <!-- <template v-if="wordList.length > 0">
                <template v-for="(syllable, index) in wordList" :key="index">
                  <span
                    class="word-syllable"
                    :class="{ active: index === activeSyllableIndex }"
                    :style="
                      index === activeSyllableIndex
                        ? { color: getSyllableActiveColor(index) }
                        : undefined
                    "
                  >
                    {{ syllable.name }}
                  </span>
                  <span v-if="index < wordList.length - 1">{{ ' ' }}</span>
                </template>
              </template> -->
              {{ currentWord.name }}
            </span>
            <div class="phonetic-symbols" v-if="currentWord.phoneticSymbols">
              {{ currentWord.phoneticSymbols }}
              <span class="horn-anim" :class="{ playing: isWordHornPlaying }">
                <img class="horn" src="@/assets/walkman/ic-horn1.png" alt="" />
                <img
                  class="wave wave1"
                  src="@/assets/walkman/ic-wave1.png"
                  alt=""
                />
                <img
                  class="wave wave2"
                  src="@/assets/walkman/ic-wave2.png"
                  alt=""
                />
              </span>
            </div>
          </div>

          <!-- <div class="split" v-if="wordList.length > 0">
            <div
              class="item"
              :class="{ active: index === activeSyllableIndex }"
              :style="
                index === activeSyllableIndex
                  ? { backgroundColor: '#ffa061', color: '#fff' }
                  : undefined
              "
              v-for="(item, index) in wordList"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div> -->

          <div
            class="explain"
            v-if="currentWord.translate"
            v-html="formatText(currentWord.translate)"
          ></div>

          <div
            class="example"
            v-if="
              (currentWord.examples && currentWord.examples.length > 0) ||
              currentWord.example
            "
          >
            <span>例句</span>
            <div class="example-content">
              <span
                v-if="currentWord.examples && currentWord.examples.length > 0"
              >
                <!-- 使用接口返回的 examples 数据 -->
                <template
                  v-for="(part, idx) in currentWord.examples[0].example.split(
                    new RegExp(`(${currentWord.name})`, 'gi')
                  )"
                  :key="idx"
                >
                  <text
                    v-if="part.toLowerCase() === currentWord.name.toLowerCase()"
                    >{{ part }}</text
                  >
                  <template v-else>{{ part }}</template>
                </template>
              </span>
              <span v-else-if="currentWord.example && currentWord.example.en">
                <template
                  v-for="(part, idx) in currentWord.example.en.split(
                    new RegExp(`(${currentWord.name})`, 'gi')
                  )"
                  :key="idx"
                >
                  <text
                    v-if="part.toLowerCase() === currentWord.name.toLowerCase()"
                    >{{ part }}</text
                  >
                  <template v-else>{{ part }}</template>
                </template>
              </span>
              <span v-else
                >The <text>{{ currentWord.name.toLowerCase() }}</text> was
                swinging from the trees.</span
              >
              <span>{{
                currentWord.examples && currentWord.examples.length > 0
                  ? currentWord.examples[0].exampleTranslate || ""
                  : currentWord.example && currentWord.example.cn
                  ? currentWord.example.cn
                  : ""
              }}</span>
            </div>
            <span
              class="horn-anim horn-anim--example"
              :class="{ playing: isExampleHornPlaying }"
            >
              <img class="horn" src="@/assets/walkman/ic-horn1.png" alt="" />
              <img
                class="wave wave1"
                src="@/assets/walkman/ic-wave1.png"
                alt=""
              />
              <img
                class="wave wave2"
                src="@/assets/walkman/ic-wave2.png"
                alt=""
              />
            </span>
          </div>
        </div>
      </div>

      <!-- 播放器控件 -->
      <PlayerControls
        :show-player-view="showPlayerView"
        :is-playing="isPlaying"
        :prev-disabled="prevBtnDisabled"
        :next-disabled="nextBtnDisabled"
        @playlist="handlePlaylistClick"
        @prev="handlePrev"
        @play-pause="handlePlayPause"
        @next="handleNext"
        @next-disabled="handleNextDisabled"
        @hide="handleHideClick"
      />

      <WalkmanPopup v-if="showPlaylist" popup-title="单词列表">
        <template #close>
          <img
            src="@/assets/walkman/ic-close.png"
            alt=""
            class="ic-close"
            @click="handleClosePlaylist"
          />
        </template>
        <template #title>
          <div class="title">
            <div class="title-icon"></div>
            <span class="title-text"
              ><span>{{ selectedWordIndex + 1 }}</span
              >/{{ totalWordCount || playlistWordList.length }}</span
            >
          </div>
        </template>
        <template #content>
          <div class="content" @scroll="handlePlaylistScroll">
            <div
              class="content-item"
              :class="{ active: selectedWordIndex === index }"
              v-for="(item, index) in playlistWordList"
              :key="index"
              @click="selectWord(index)"
            >
              <div class="word-name">{{ item.name || item.word }}</div>
              <div
                class="word-info"
                v-html="formatText(item.translate || item.translation)"
              ></div>
              <div class="audio-icon" v-if="selectedWordIndex === index">
                <img src="@/assets/walkman/ic-voice.png" />
              </div>
            </div>
            <!-- 没有更多数据提示 -->
            <div
              v-if="
                playlistWordList.length > 0 &&
                !pageDataPagination.hasNextPage &&
                isAllListLoaded
              "
              class="no-more-data"
            >
              没有更多数据了
            </div>
          </div>
        </template>
      </WalkmanPopup>

      <!-- 设置弹窗 -->
      <SettingsPopup
        v-if="showSettings"
        :settings="settings"
        @close="handleCloseSettings"
        @confirm="handleConfirmSettings"
      />
    </template>

    <!-- Player 视图内容 -->
    <template v-if="showPlayerView">
      <div class="header">
        <img
          src="@/assets/walkman/ic-back.png"
          alt=""
          class="ic-back"
          @click="handleBackClick"
        />

        <div class="header-title">随身听</div>

        <div class="setting" @click="handleSettingClick">
          <img src="@/assets/walkman/ic-setting.png" />
          设置
        </div>
      </div>

      <div class="card">
        <!-- 空状态：数据没加载出来时显示（包括加载中） -->
        <div class="empty-state" v-if="playlistWordList.length === 0">
          <img src="@/assets/empty.png" alt="空状态" />
        </div>

        <div class="player-container" v-else>
          <!-- 唱片机主体 -->
          <div class="record-player">
            <!-- 唱臂 -->
            <div class="tonearm" :class="{ playing: isPlaying }"></div>

            <!-- 唱片区域 -->
            <div class="record-disc" :class="{ rotating: isPlaying }">
              <!-- 专辑封面 -->
              <div class="album-cover">
                <img
                  :src="currentWord?.wordImg || currentWord?.audio?.wordImg"
                />
              </div>
            </div>
          </div>

          <!-- 进度指示器 -->
          <div class="progress-indicator">
            <span>{{
              playlistWordList.length > 0 ? currentWordIndex + 1 : 1
            }}</span
            >/<span class="total-count">{{
              totalWordCount || playlistWordList.length || 30
            }}</span>
          </div>
        </div>
      </div>

      <!-- 播放器控件 -->
      <PlayerControls
        :show-player-view="showPlayerView"
        :is-playing="isPlaying"
        :prev-disabled="prevBtnDisabled"
        :next-disabled="nextBtnDisabled"
        @playlist="handlePlaylistClick"
        @prev="handlePrev"
        @play-pause="handlePlayPause"
        @next="handleNext"
        @next-disabled="handleNextDisabled"
        @hide="handleHideClick"
      />

      <WalkmanPopup v-if="showPlaylist" popup-title="单词列表">
        <template #close>
          <img
            src="@/assets/walkman/ic-close.png"
            alt=""
            class="ic-close"
            @click="handleClosePlaylist"
          />
        </template>
        <template #title>
          <div class="title">
            <div class="title-icon"></div>
            <span class="title-text"
              ><span>{{ selectedWordIndex + 1 }}</span
              >/{{ totalWordCount || playlistWordList.length }}</span
            >
          </div>
        </template>
        <template #content>
          <div class="content" @scroll="handlePlaylistScroll">
            <div
              class="content-item"
              :class="{ active: selectedWordIndex === index }"
              v-for="(item, index) in playlistWordList"
              :key="index"
              @click="selectWord(index)"
            >
              <div class="word-name">{{ item.name || item.word }}</div>
              <div
                class="word-info"
                v-html="formatText(item.translate || item.translation)"
              ></div>
              <div class="audio-icon" v-if="selectedWordIndex === index">
                <img src="@/assets/walkman/ic-voice.png" />
              </div>
            </div>
            <!-- 没有更多数据提示 -->
            <div
              v-if="
                playlistWordList.length > 0 &&
                !pageDataPagination.hasNextPage &&
                isAllListLoaded
              "
              class="no-more-data"
            >
              没有更多数据了
            </div>
          </div>
        </template>
      </WalkmanPopup>

      <!-- 设置弹窗 -->
      <SettingsPopup
        v-if="showSettings"
        :settings="settings"
        @close="handleCloseSettings"
        @confirm="handleConfirmSettings"
      />
    </template>

    <!-- 音频播放器（放在外层，避免被 v-if 清除） -->
    <audio
      ref="audioPlayer"
      @ended="handleAudioEnded"
      @error="handleAudioError"
    ></audio>

    <!-- Toast 提示 -->
    <div
      v-if="toastMessage"
      class="toast"
      :class="{ show: toastMessage, loading: isLoadingToast }"
    >
      <span v-if="isLoadingToast" class="loading-spinner"></span>
      {{ toastMessage }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, nextTick } from "vue";
import WalkmanPopup from "./components/Walkman-popup.vue";
import SettingsPopup from "./components/Settings-popup.vue";
import PlayerControls from "./components/PlayerControls.vue";
import { pageListenWords } from "@/api/player.js";

const currentWordIndex = ref(0);
const wordList = ref([]);
// 当前正在播放的音节索引（用于音节高亮）
const activeSyllableIndex = ref(-1);
const audioPlayer = ref(null);
const isPlaying = ref(false);
const showPlayerView = ref(false); // 控制显示哪个视图
const bookId = ref("");
// 分页加载相关
const isLoadingPageData = ref(false); // 是否正在加载分页数据
const pageDataPagination = ref({
  page: 1, // 从第1页开始加载
  pageSize: 10,
  hasNextPage: true,
});
// 播放队列相关
const playQueue = ref([]); // 当前播放队列
const currentPlayIndex = ref(0); // 当前播放队列索引
const currentWordPlayCount = ref(0); // 当前单词已播放次数（用于控制单个单词播放次数）
const listLoopCount = ref(0); // 列表循环次数（用于控制整个列表循环次数）
const isPlayingQueue = ref(false); // 是否正在播放队列
const currentAudioUrl = ref(""); // 当前播放的音频URL
const WORD_PAUSE_MS = 800; // 每个单词播完后的停顿时间，避免切换过快
const pausedTime = ref(0); // 暂停时的播放时间（秒）
const toastMessage = ref(""); // Toast 提示消息
const toastTimer = ref(null); // Toast 定时器
const nextWordTimer = ref(null); // 延迟播放下一个单词的定时器
const isFirstLoad = ref(true); // 是否是第一次加载列表
const isLoadingToast = ref(false); // 是否是 loading toast
// 首屏列表加载中：禁用切词/播放等交互
const isInitialListLoading = ref(false);
// 是否开启后台自动预加载剩余分页（避免“从首位点上一首跳末尾/切换播放没数据”）
const autoPrefetchEnabled = ref(true);
// 标记“加载中...”是否由滚动触发显示（用于在非 scroll 触发的请求完成后也能关闭）
const scrollLoadingToastShown = ref(false);
// 当前正在播放的队列项类型（用于控制喇叭动画显示位置）
const currentPlayingItemType = ref("");
// 标记“加载中...”是否由按钮触发（next）
const nextBtnLoadingToastShown = ref(false);
// 播放会话 token：用于避免快速切词导致旧回调串台
const playbackSessionId = ref(0);
// 播放启动延迟（避免切换过程中按钮动画抖动/串音）
const PLAY_START_DELAY_MS = 180;
let playStartTimer = null;
// 切歌后“先暂停再播放”的延迟
const SWITCH_PLAY_DELAY_MS = 220;
let switchPlayTimer = null;

// 统一的 UI 禁用开关（首屏列表 loading 时禁用切词&播放）
const controlsDisabled = computed(() => isInitialListLoading.value);

// 单词位置喇叭：读单词/音节/释义时动
const isWordHornPlaying = computed(() => {
  if (!isPlaying.value) return false;
  return ["word", "syllable", "translate"].includes(
    currentPlayingItemType.value
  );
});
// 例句位置喇叭：读例句/例句翻译时动
const isExampleHornPlaying = computed(() => {
  if (!isPlaying.value) return false;
  return ["example", "exampleTranslate"].includes(currentPlayingItemType.value);
});

// last-btn（上一首/跳到末尾）禁用：当列表还没加载完全部数据时禁用
const isAllListLoaded = computed(() => {
  // 还有下一页，说明未加载完
  if (pageDataPagination.value.hasNextPage) return false;
  // 如果有总数且当前长度不足，也说明未加载完
  if (
    totalWordCount.value &&
    playlistWordList.value.length < totalWordCount.value
  )
    return false;
  return true;
});
// “上一首”只在“当前是第 1 个 且 未全量加载（无法跳末尾）”时禁用
const prevBtnDisabled = computed(() => {
  if (playlistWordList.value.length === 0) return false;
  if (selectedWordIndex.value !== 0) return false; // 不在第一位，不禁用

  // 在第一位时：
  // 情况1：未全量加载，禁用（保留原有逻辑）
  if (!isAllListLoaded.value) {
    return true;
  }

  // 情况2：未开启循环播放，禁用（新增逻辑）
  if (settings.value.loopStatus === 0) {
    return true;
  }

  return false;
});

// “下一首”在“已经到达当前已加载列表末尾，但还有下一页没拉到”时禁用
const nextBtnDisabled = computed(() => {
  if (playlistWordList.value.length === 0) return false;
  const atLoadedEnd =
    selectedWordIndex.value >= playlistWordList.value.length - 1;

  // 情况1：数据未加载完成时禁用（保留原有逻辑）
  if (atLoadedEnd && pageDataPagination.value.hasNextPage) {
    return true;
  }

  // 情况2：没有开启循环播放，且当前是最后一个单词，且已经加载完所有数据
  if (
    settings.value.loopStatus === 0 && // 没有开启循环播放
    atLoadedEnd && // 当前是最后一个单词
    isAllListLoaded.value // 已经加载完所有数据
  ) {
    return true;
  }

  return false;
});

const handleNextDisabled = () => {
  // 检查是否是没有开启循环播放，且是最后一个单词，且已经加载完所有数据
  const atLoadedEnd =
    selectedWordIndex.value >= playlistWordList.value.length - 1;
  const isLastWordNoLoop =
    settings.value.loopStatus === 0 && // 没有开启循环播放
    atLoadedEnd && // 当前是最后一个单词
    isAllListLoaded.value && // 已经加载完所有数据
    !pageDataPagination.value.hasNextPage; // 没有下一页

  // 如果是这种情况，不需要显示 loading，直接返回
  // 如果之前已经显示了 loading，也要关闭它
  if (isLastWordNoLoop) {
    if (nextBtnLoadingToastShown.value && isLoadingToast.value) {
      hideLoadingToast();
      nextBtnLoadingToastShown.value = false;
    }
    return;
  }

  // 下一个数据还没加载出来：提示加载中，并尝试触发加载
  nextBtnLoadingToastShown.value = true;
  showLoadingToast("加载中...");
  if (!isLoadingPageData.value && pageDataPagination.value.hasNextPage) {
    loadPageData({ trigger: "nextBtn" });
  }
};

// 切歌/选词前统一重置播放相关状态，避免上一首/下一首残留状态影响下一首播放
const resetPlaybackState = () => {
  // 递增会话 id，使所有旧的异步回调失效
  playbackSessionId.value += 1;

  // 清除延迟播放定时器
  if (nextWordTimer.value) {
    clearTimeout(nextWordTimer.value);
    nextWordTimer.value = null;
  }
  // 清除“播放启动延迟”定时器
  if (playStartTimer) {
    clearTimeout(playStartTimer);
    playStartTimer = null;
  }
  // 清除“切歌延迟播放”定时器
  if (switchPlayTimer) {
    clearTimeout(switchPlayTimer);
    switchPlayTimer = null;
  }

  // 停止当前音频并清空 src，防止 onended 串触发
  if (audioPlayer.value) {
    try {
      audioPlayer.value.pause();
      audioPlayer.value.src = "";
      audioPlayer.value.load?.();
    } catch (e) {
      // ignore
    }
  }

  // 重置播放状态
  isPlaying.value = false;
  isPlayingQueue.value = false;
  playQueue.value = [];
  currentPlayIndex.value = 0;
  pausedTime.value = 0;
  currentAudioUrl.value = "";
  currentWordPlayCount.value = 0;

  // 重置 UI 相关状态
  activeSyllableIndex.value = -1;
  currentPlayingItemType.value = "";
};

// 切歌后：先暂停一小段时间，再开始播放当前单词
const schedulePlayCurrentWord = () => {
  resetPlaybackState();
  // 保持暂停态一小段时间（视觉/音频都更稳定）
  if (switchPlayTimer) {
    clearTimeout(switchPlayTimer);
    switchPlayTimer = null;
  }
  switchPlayTimer = setTimeout(() => {
    switchPlayTimer = null;
    if (controlsDisabled.value) return;
    playCurrentWord();
  }, SWITCH_PLAY_DELAY_MS);
};

const showPlaylist = ref(false);
const handlePlaylistClick = () => {
  if (controlsDisabled.value) return;
  showPlaylist.value = true;
};
const handleClosePlaylist = () => {
  showPlaylist.value = false;
};

const selectedWordIndex = ref(0); // 默认选中第一个

const playlistWordList = ref([]);
const totalWordCount = ref(0); // 单词列表总数（从安卓传过来）

// 默认单词数据
const defaultWord = {
  name: "Monkey",
  phoneticSymbols: "/ˈmʌŋki/",
  translate: "N. (名词) 猴子；猴；猿猴\\nV. (动词) 胡闹；捣蛋；瞎摆弄",
  audioUrl: "",
  example: {
    en: "The monkey was swinging from the trees.",
    cn: "这只猴子在树林间荡来荡去。",
  },
};

// 当前选中的单词
const currentWord = computed(() => {
  if (
    playlistWordList.value.length > 0 &&
    selectedWordIndex.value >= 0 &&
    selectedWordIndex.value < playlistWordList.value.length
  ) {
    return playlistWordList.value[selectedWordIndex.value];
  }
  // 如果没有数据，返回默认值
  return defaultWord;
});

// 拆分单词为音节（使用接口返回的 syllables 数据）
const splitWord = (word) => {
  if (!word) return [];
  // 优先使用接口返回的 syllables 数据
  if (
    word.syllables &&
    Array.isArray(word.syllables) &&
    word.syllables.length > 0 &&
    word.syllables[0].syllablesWord
  ) {
    return word.syllables.map((syllable) => ({
      name: syllable.syllablesWord || "",
      audioUrl: syllable.syllablesUrl || "",
    }));
  }
  // 如果没有 syllables 数据，按字符拆分作为后备方案
  return word.name ? word.name.split("").map((char) => ({ name: char })) : [];
};

// 计算当前单词的字符长度
const wordCharLength = computed(() => {
  if (wordList.value.length > 0) {
    // 如果有 wordList，计算所有音节的总长度
    return wordList.value.reduce((total, syllable) => {
      return total + (syllable.name || "").length;
    }, 0);
  } else if (currentWord.value && currentWord.value.name) {
    // 如果没有 wordList，使用 currentWord.name 的长度
    return currentWord.value.name.length;
  }
  return 0;
});

// 根据字符长度返回字体大小
const wordFontSize = computed(() => {
  return wordCharLength.value > 9 ? "59px" : "89px";
});

// 监听当前单词变化，更新显示
watch(
  currentWord,
  (newWord, oldWord) => {
    if (newWord) {
      // 只有在有实际数据时才更新索引
      if (playlistWordList.value.length > 0) {
        currentWordIndex.value = selectedWordIndex.value;
      } else {
        // 使用默认值时，索引保持为0
        currentWordIndex.value = 0;
      }
      wordList.value = splitWord(newWord);
      // 如果正在播放且单词发生变化，自动播放新单词
      if (
        isPlaying.value &&
        oldWord &&
        newWord.name !== oldWord.name &&
        newWord.audioUrl
      ) {
        playCurrentWord();
      }
    }
  },
  { immediate: true, deep: true }
);

// 监听播放列表变化，默认选中第一项
watch(
  playlistWordList,
  (newList) => {
    if (newList.length > 0 && selectedWordIndex.value === 0) {
      // 确保选中第一项
      selectedWordIndex.value = 0;
    }
  },
  { immediate: true }
);

const selectWord = (index) => {
  if (controlsDisabled.value) return;
  schedulePlayCurrentWord();

  selectedWordIndex.value = index;
  currentWordIndex.value = index;

  // 如果切换到第一个单词，重置列表循环计数
  if (index === 0) {
    listLoopCount.value = 0;
  }

  // 关闭弹窗
  showPlaylist.value = false;

  // 自动播放选中的单词
  // schedulePlayCurrentWord 已负责延迟后播放
};

// 显示 Toast 提示
const showToast = (message, duration = 2000) => {
  isLoadingToast.value = false;
  toastMessage.value = message;
  if (toastTimer.value) {
    clearTimeout(toastTimer.value);
  }
  toastTimer.value = setTimeout(() => {
    toastMessage.value = "";
    toastTimer.value = null;
    isLoadingToast.value = false;
  }, duration);
};

// 显示 Loading Toast（不会自动消失，需要手动调用 hideLoadingToast 关闭）
const showLoadingToast = (message = "加载中...") => {
  isLoadingToast.value = true;
  toastMessage.value = message;
  if (toastTimer.value) {
    clearTimeout(toastTimer.value);
    toastTimer.value = null;
  }
};

// 隐藏 Loading Toast
const hideLoadingToast = () => {
  isLoadingToast.value = false;
  toastMessage.value = "";
  if (toastTimer.value) {
    clearTimeout(toastTimer.value);
    toastTimer.value = null;
  }
};

// 单词列表滚动到底：如果还没加载完则提示/触发加载
const handlePlaylistScroll = (e) => {
  const el = e?.target;
  if (!el) return;
  // 距离底部阈值（px）
  const threshold = 50;
  const isNearBottom =
    el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
  if (!isNearBottom) return;
  // 还有下一页时：如果正在加载就提示 loading；否则触发加载并提示 loading
  if (pageDataPagination.value.hasNextPage) {
    if (isLoadingPageData.value) {
      if (!isLoadingToast.value) {
        scrollLoadingToastShown.value = true;
        showLoadingToast("加载中...");
      }
      return;
    }
    scrollLoadingToastShown.value = true;
    showLoadingToast("加载中...");
    loadPageData({ trigger: "scroll" });
  }
};

// 确保把剩余分页都加载完（用于“从首位点上一首跳末尾”等场景）
const loadAllRemainingPages = async () => {
  // 关键兜底：如果必要参数未就绪，直接退出，避免死循环卡死交互
  if (!bookId.value) return;
  // 防止后台预加载和这里同时抢占
  const prevAuto = autoPrefetchEnabled.value;
  autoPrefetchEnabled.value = false;
  try {
    // 进度检测：如果 loadPageData 没有推进分页（例如被条件短路 return），立刻 break，避免卡死
    let safety = 200; // 最大页数保护（防止意外）
    while (pageDataPagination.value.hasNextPage && safety-- > 0) {
      const beforePage = pageDataPagination.value.currentPage;
      const beforeLen = playlistWordList.value.length;
      // eslint-disable-next-line no-await-in-loop
      await loadPageData({ trigger: "ensureAll" });
      const afterPage = pageDataPagination.value.currentPage;
      const afterLen = playlistWordList.value.length;

      // 如果页码和列表长度都没变化，说明本次没有任何推进，直接退出
      if (afterPage === beforePage && afterLen === beforeLen) {
        break;
      }
    }
  } finally {
    autoPrefetchEnabled.value = prevAuto;
  }
};

// 查找下一个有音频数据的单词索引
const findNextWordWithAudio = (startIndex) => {
  for (let i = startIndex; i < playlistWordList.value.length; i++) {
    const word = playlistWordList.value[i];
    if (word && word.audioUrl) {
      return i;
    }
  }
  // 如果没找到，从头开始找
  for (let i = 0; i < startIndex; i++) {
    const word = playlistWordList.value[i];
    if (word && word.audioUrl) {
      return i;
    }
  }
  return -1; // 没有找到有音频的单词
};

// 根据设置构建播放队列
const buildPlayQueue = () => {
  if (!currentWord.value) {
    return [];
  }

  const queue = [];
  const word = currentWord.value;
  //   wordSyllablesStatus: settings.value.wordSyllablesStatus,
  //   wordTranslateStatus: settings.value.wordTranslateStatus,
  //   wordExampleStatus: settings.value.wordExampleStatus,
  //   loopStatus: settings.value.loopStatus,
  //   loopCount: settings.value.loopCount
  // });

  // 1. 单词音频（总是播放）
  if (word.audioUrl) {
    queue.push({
      type: "word",
      url: word.audioUrl,
      name: word.name,
    });
  }

  // 2. 单词音节音频（如果开启）- 放在单词音频之后立即播放
  // word.syllables 是数组，遍历每个音节对象，访问 syllablesUrl
  if (
    settings.value.wordSyllablesStatus === 1 &&
    word.syllables &&
    Array.isArray(word.syllables)
  ) {
    for (let i = 0; i < word.syllables.length; i++) {
      const syllable = word.syllables[i];
      if (syllable && syllable.syllablesUrl) {
        queue.push({
          type: "syllable",
          url: syllable.syllablesUrl, // word.syllables[i].syllablesUrl
          name: syllable.syllablesWord || "",
          syllableIndex: i,
        });
      }
    }
  }

  // 3. 单词释义音频（如果开启）
  if (settings.value.wordTranslateStatus === 1 && word.translate) {
    // 使用接口返回的 translateAudio.audioUrl
    if (word.translateAudio && word.translateAudio.audioUrl) {
      queue.push({
        type: "translate",
        url: word.translateAudio.audioUrl,
        name: word.translate,
      });
    }
  }

  // 4. 单词例句音频（如果开启）
  if (settings.value.wordExampleStatus === 1) {
    // 优先使用接口返回的 examples 数据
    if (word.examples && word.examples.length > 0) {
      const example = word.examples[0];
      // 例句英文音频
      if (example.exampleAudio) {
        queue.push({
          type: "example",
          url: example.exampleAudio,
          name: example.example,
        });
      }
      // 例句中文音频
      if (example.exampleTranslateAudio) {
        queue.push({
          type: "exampleTranslate",
          url: example.exampleTranslateAudio,
          name: example.exampleTranslate,
        });
      }
    }
  }

  return queue;
};

// 播放队列中的下一项
const playNextInQueue = () => {
  const sessionId = playbackSessionId.value;

  if (!isPlayingQueue.value) {
    return;
  }

  if (playQueue.value.length === 0) {
    isPlayingQueue.value = false;
    isPlaying.value = false;
    return;
  }

  // 确保索引有效
  if (currentPlayIndex.value < 0) {
    currentPlayIndex.value = 0;
  }

  if (currentPlayIndex.value >= playQueue.value.length) {
    // 队列播放完成，自动播放下一个单词（列表循环在 handleNext 中处理）
    isPlayingQueue.value = false;
    // 注意：这里不要立即调用 handleNext，因为 handleAudioEnded 可能会再次调用 playNextInQueue
    // 所以先返回，让 handleAudioEnded 来处理
    return;
  }

  const currentItem = playQueue.value[currentPlayIndex.value];
  if (!currentItem) {
    // 跳过该项，继续下一项
    currentPlayIndex.value++;
    playNextInQueue();
    return;
  }

  if (!currentItem.url) {
    currentPlayIndex.value++;
    playNextInQueue();
    return;
  }

  // 记录当前播放项类型，用于控制喇叭动画显示位置
  currentPlayingItemType.value = currentItem.type || "";

  // 播放到音节时高亮对应音节；播放其它项则取消高亮
  if (currentItem.type === "syllable") {
    // syllableIndex 可能是 number 或 string（做一次数值化，避免一直命中第 0 个颜色）
    const idxFromQueue = Number(currentItem.syllableIndex);
    if (Number.isFinite(idxFromQueue) && idxFromQueue >= 0) {
      activeSyllableIndex.value = idxFromQueue;
    } else {
      // 兼容旧数据：没有下发 syllableIndex 时，用 url 回退匹配
      const idx = wordList.value.findIndex(
        (s) => s && s.audioUrl && s.audioUrl === currentItem.url
      );
      activeSyllableIndex.value = idx >= 0 ? idx : -1;
    }
  } else {
    activeSyllableIndex.value = -1;
  }

  if (audioPlayer.value && currentItem.url) {
    // 如果音频URL相同且之前有暂停时间，恢复播放位置
    if (currentAudioUrl.value === currentItem.url && pausedTime.value > 0) {
      audioPlayer.value.src = currentItem.url;
      audioPlayer.value.currentTime = pausedTime.value;
      pausedTime.value = 0; // 重置暂停时间
    } else {
      // 新的音频，从头开始播放
      audioPlayer.value.src = currentItem.url;
      audioPlayer.value.currentTime = 0;
    }

    // 更新当前播放的音频URL
    currentAudioUrl.value = currentItem.url;

    // 先强制加载，再播放，避免切换过快导致播放失败
    try {
      audioPlayer.value.load();
      if (playStartTimer) {
        clearTimeout(playStartTimer);
        playStartTimer = null;
      }
      playStartTimer = setTimeout(() => {
        // 如果期间切词/重置了，会话 id 已变化，直接忽略
        if (sessionId !== playbackSessionId.value) return;
        audioPlayer.value
          .play()
          .then(() => {
            if (sessionId !== playbackSessionId.value) return;
            // 确保播放状态为 true
            isPlaying.value = true;
          })
          .catch((error) => {
            if (sessionId !== playbackSessionId.value) return;
            console.log(error, "error");
            // 播放失败，继续下一项
            currentPlayIndex.value++;
            playNextInQueue();
          });
      }, PLAY_START_DELAY_MS); // 给切换/重置一点时间，再触发真正播放
    } catch (error) {
      if (sessionId !== playbackSessionId.value) return;
      console.log(error, "error");
      currentPlayIndex.value++;
      playNextInQueue();
    }
  } else {
    // 没有音频URL，继续下一项
    showToast(`缺少音频数据：${currentItem.type}`);
    currentPlayIndex.value++;
    playNextInQueue();
  }
};

// 播放当前单词（根据设置）
const playCurrentWord = () => {
  // 新一轮播放开始：递增会话 id，清掉旧回调
  playbackSessionId.value += 1;
  // 先停止当前播放，确保状态完全重置
  if (audioPlayer.value) {
    audioPlayer.value.pause();
    audioPlayer.value.src = ""; // 清空音频源
  }
  // 重置当前播放类型（喇叭动画跟随队列项）
  currentPlayingItemType.value = "";

  // 切换单词/重新播放时，先清掉音节高亮
  activeSyllableIndex.value = -1;

  // 先关闭播放状态，确保状态完全重置
  isPlayingQueue.value = false;

  // 清空旧队列，避免使用上一个单词的队列
  playQueue.value = [];

  // 重置播放索引和所有相关状态（但不清空 currentWordPlayCount，因为需要记录当前单词播放次数）
  currentPlayIndex.value = 0;
  pausedTime.value = 0;
  currentAudioUrl.value = "";

  // 检查当前单词是否存在
  if (!currentWord.value) {
    showToast("当前单词数据不存在");
    isPlaying.value = false;
    return;
  }

  // 构建新的播放队列（必须在重置索引和清空队列之后）
  const newQueue = buildPlayQueue();

  if (newQueue.length === 0) {
    showToast("当前单词没有音频数据");
    isPlaying.value = false;
    isPlayingQueue.value = false;
    return;
  }

  // 设置新队列
  playQueue.value = newQueue;

  // 确保索引从0开始
  currentPlayIndex.value = 0;

  // 开启队列播放状态（isPlaying 由真正 play 成功后再置为 true）
  isPlayingQueue.value = true;
  isPlaying.value = false;

  // 开始播放队列
  playNextInQueue();
};

// 暂停播放
const pauseAudio = () => {
  // 清除延迟播放的定时器
  if (nextWordTimer.value) {
    clearTimeout(nextWordTimer.value);
    nextWordTimer.value = null;
  }

  if (audioPlayer.value) {
    // 保存当前播放时间和音频URL
    pausedTime.value = audioPlayer.value.currentTime;
    currentAudioUrl.value = audioPlayer.value.src;
    audioPlayer.value.pause();
    isPlaying.value = false;
    currentPlayingItemType.value = "";
    // 注意：不重置 isPlayingQueue，保持队列状态以便恢复播放
  }
};

// 播放/暂停切换
const handlePlayPause = () => {
  if (controlsDisabled.value) return;
  // 如果用户手动点击播放，清除延迟播放的定时器
  if (nextWordTimer.value) {
    clearTimeout(nextWordTimer.value);
    nextWordTimer.value = null;
  }

  if (isPlaying.value) {
    pauseAudio();
  } else {
    // 检查当前单词是否有音频数据
    const queue = buildPlayQueue();
    if (queue.length === 0) {
      // 当前单词没有音频数据，查找下一个有音频的单词
      const nextIndex = findNextWordWithAudio(selectedWordIndex.value + 1);
      if (nextIndex !== -1) {
        showToast("当前单词没有音频数据，已跳转到下一个有音频的单词");
        selectedWordIndex.value = nextIndex;
        currentWordIndex.value = nextIndex;
        pausedTime.value = 0;
        currentAudioUrl.value = "";
        playCurrentWord();
      } else {
        showToast("没有找到可播放的音频数据");
        isPlaying.value = false;
      }
      return;
    }

    // 如果之前有播放队列且暂停时间存在，尝试恢复播放
    if (
      playQueue.value.length > 0 &&
      pausedTime.value > 0 &&
      currentAudioUrl.value &&
      audioPlayer.value
    ) {
      // 检查当前队列项是否匹配暂停的音频
      const currentItem = playQueue.value[currentPlayIndex.value];
      if (currentItem && currentItem.url === currentAudioUrl.value) {
        // 恢复播放同一音频
        audioPlayer.value.src = currentAudioUrl.value;
        audioPlayer.value.currentTime = pausedTime.value;
        isPlayingQueue.value = true; // 恢复队列播放状态

        audioPlayer.value
          .play()
          .then(() => {
            isPlaying.value = true;
            pausedTime.value = 0; // 清除暂停时间
          })
          .catch((error) => {
            console.log(error, "error");
            showToast("恢复播放失败");
            // 恢复失败，重新开始播放
            pausedTime.value = 0;
            currentAudioUrl.value = "";
            playCurrentWord();
          });
        return;
      }
    }

    // 没有暂停记录或队列不匹配，重新开始播放
    pausedTime.value = 0;
    currentAudioUrl.value = "";
    playCurrentWord();
  }
};

// 上一首
const handlePrev = async (_autoPlay = false) => {
  if (playlistWordList.value.length === 0) return;
  if (controlsDisabled.value) return;

  // 无论是否在播放，只要切歌就自动播放（按需求）
  resetPlaybackState();

  // 如果在第一个单词点“上一首”，需要跳到末尾：若分页还没加载完，先把剩余页拉完
  if (selectedWordIndex.value === 0 && pageDataPagination.value.hasNextPage) {
    showLoadingToast("加载中...");
    await loadAllRemainingPages();
    hideLoadingToast();
  }

  const prevIndex =
    selectedWordIndex.value > 0
      ? selectedWordIndex.value - 1
      : playlistWordList.value.length - 1;

  selectedWordIndex.value = prevIndex;
  currentWordIndex.value = prevIndex;

  // 如果切换到第一个单词，重置列表循环计数
  if (prevIndex === 0) {
    listLoopCount.value = 0;
  }

  // 切歌后：先暂停再播放
  schedulePlayCurrentWord();
};

// 下一首
const handleNext = (autoPlay = false) => {
  if (playlistWordList.value.length === 0) return;
  if (controlsDisabled.value) return;

  // 无论是否在播放，只要切歌就自动播放（按需求）
  resetPlaybackState();

  // 计算下一个索引
  const isLastWord =
    selectedWordIndex.value >= playlistWordList.value.length - 1;
  let nextIndex;

  if (isLastWord) {
    // 到达最后一个单词，检查列表循环设置
    if (settings.value.loopStatus === 1) {
      // 列表循环播放模式：继续循环，回到第一个单词
      listLoopCount.value++;
      nextIndex = 0;
    } else {
      // 非循环模式：停止播放
      listLoopCount.value = 0;
      isPlaying.value = false;
      return;
    }
  } else {
    // 不是最后一个单词，正常下一个
    nextIndex = selectedWordIndex.value + 1;
  }

  selectedWordIndex.value = nextIndex;
  currentWordIndex.value = nextIndex;

  // 如果手动切换到第一个单词（非自动播放），重置列表循环计数
  // 自动播放时（循环回到开头）不重置，因为列表循环计数已经在上面增加了
  if (nextIndex === 0 && !autoPlay) {
    listLoopCount.value = 0;
  }

  // 切歌后：先暂停再播放
  schedulePlayCurrentWord();
};

// 音频播放结束
const handleAudioEnded = () => {
  if (isPlayingQueue.value) {
    // 播放队列模式：播放下一项
    const nextIndex = currentPlayIndex.value + 1;

    // 检查是否已经播放完队列中的所有项
    if (nextIndex >= playQueue.value.length) {
      currentPlayingItemType.value = "";
      // 队列播放完成，检查当前单词是否已达到设置的播放次数
      currentWordPlayCount.value++;

      if (currentWordPlayCount.value < settings.value.loopCount) {
        // 当前单词还没播放够次数，重新播放当前单词
        // 重置队列索引，重新播放
        currentPlayIndex.value = 0;
        pausedTime.value = 0;
        currentAudioUrl.value = "";
        // 清除之前的定时器（如果存在）
        if (nextWordTimer.value) {
          clearTimeout(nextWordTimer.value);
        }
        // 加一个停顿，再重新播放当前单词
        nextWordTimer.value = setTimeout(() => {
          nextWordTimer.value = null;
          playNextInQueue();
        }, WORD_PAUSE_MS);
      } else {
        // 当前单词已播放够次数，播放下一个单词
        // 重置当前单词播放次数
        currentWordPlayCount.value = 0;
        // 先关闭队列播放状态，但保持 isPlaying 为 true，避免按钮闪烁
        isPlayingQueue.value = false;
        if (audioPlayer.value) {
          audioPlayer.value.pause();
        }
        // 清空旧队列，确保下一个单词使用新的队列
        playQueue.value = [];
        // 重置索引，确保下一个单词从0开始
        currentPlayIndex.value = 0;
        // 重置其他状态
        pausedTime.value = 0;
        currentAudioUrl.value = "";
        // 清除之前的定时器（如果存在）
        if (nextWordTimer.value) {
          clearTimeout(nextWordTimer.value);
        }
        // 加一个停顿，再自动播放下一个单词（保持 isPlaying 为 true，避免按钮闪烁）
        nextWordTimer.value = setTimeout(() => {
          nextWordTimer.value = null;
          handleNext(true);
        }, WORD_PAUSE_MS);
      }
    } else {
      // 继续播放队列中的下一项
      currentPlayIndex.value = nextIndex;
      playNextInQueue();
    }
  } else {
    // 非队列模式（兼容旧逻辑）：自动下一首
    // 清除之前的定时器（如果存在）
    if (nextWordTimer.value) {
      clearTimeout(nextWordTimer.value);
    }
    // 加一个停顿，再自动播放下一个单词
    nextWordTimer.value = setTimeout(() => {
      nextWordTimer.value = null;
      handleNext(true);
    }, WORD_PAUSE_MS);
  }
};

// 音频播放错误
const handleAudioError = (error) => {
  console.log(error, "error");
  // showToast("音频播放出错，请检查网络连接");
  isPlaying.value = false;
  isPlayingQueue.value = false;
  currentPlayingItemType.value = "";
};

const showSettings = ref(false);
const handleSettingClick = () => {
  showSettings.value = true;
};
const handleCloseSettings = () => {
  showSettings.value = false;
};

// 返回按钮点击事件
const handleBackClick = () => {
  // // 如果在 player 视图，返回首页
  // if (showPlayerView.value) {
  //   showPlayerView.value = false;
  //   return;
  // }
  // 否则退出应用
  const quitRequest = JSON.stringify({
    func: "quit",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  }
};

// 隐藏/显示 player 视图（不打断播放）
const handleHideClick = () => {
  // 只切换视图，不停止播放
  showPlayerView.value = !showPlayerView.value;
  // 注意：不调用 pauseAudio()，保持当前播放状态
};

// 设置选项 - 统一使用 Android 字段格式
const settings = ref({
  wordTranslateStatus: 1, // 朗读单词释义：0-关闭，1-朗读（默认开启）
  wordSyllablesStatus: 0, // 朗读单词音节状态：0-关闭，1-朗读（默认关闭）
  wordExampleStatus: 1, // 朗读单词例句：0-关闭，1-朗读（默认开启）
  loopStatus: 1, // 循环播放：0-关闭，1-开启（默认开启）
  loopCount: 1, // 循环次数（默认1次）
});

// 保存单个设置字段到 Android 本地
const saveSettingsToAndroid = (key, value) => {
  const requestData = {
    keyStr: key, // 直接使用字段名作为 keyStr
    valueStr: String(value), // 将值转换为字符串
  };
  if (window.android && window.android.callNative) {
    window.android.callNative(
      JSON.stringify({
        func: "getEncodeDataMMKV",
        params: requestData,
      })
    );
  }
};

// 从 Android 本地读取设置 - 每个字段单独读取
const loadSettingsFromAndroid = () => {
  // 读取所有设置字段
  const keys = [
    "wordTranslateStatus",
    "wordSyllablesStatus",
    "wordExampleStatus",
    "loopStatus",
    "loopCount",
  ];

  keys.forEach((keyStr) => {
    const requestData = {
      keyStr: keyStr,
    };
    if (window.android && window.android.callNative) {
      window.android.callNative(
        JSON.stringify({
          func: "getDecodeDataMMKV",
          params: requestData,
        })
      );
    }
  });
};

const handleConfirmSettings = (newSettings) => {
  const oldLoopStatus = settings.value.loopStatus;
  const wasPlaying = isPlaying.value || isPlayingQueue.value;

  // 检查播放相关的设置是否改变（音节、释义、例句、播放次数）
  const playbackSettingsChanged =
    settings.value.wordSyllablesStatus !== newSettings.wordSyllablesStatus ||
    settings.value.wordTranslateStatus !== newSettings.wordTranslateStatus ||
    settings.value.wordExampleStatus !== newSettings.wordExampleStatus ||
    settings.value.loopCount !== newSettings.loopCount;

  // 更新设置
  settings.value = { ...newSettings };

  // 如果列表循环播放被关闭，重置列表循环计数
  if (oldLoopStatus === 1 && newSettings.loopStatus === 0) {
    listLoopCount.value = 0;
  }

  // 如果播放相关的设置改变了，需要重新构建队列
  if (playbackSettingsChanged) {
    // 如果播放次数改变，重置当前单词播放次数，以便应用新的播放次数
    if (settings.value.loopCount !== newSettings.loopCount) {
      currentWordPlayCount.value = 0;
    }

    // 如果正在播放队列，重新构建播放队列以应用新设置
    if (wasPlaying && isPlayingQueue.value) {
      // 停止当前播放
      if (audioPlayer.value) {
        audioPlayer.value.pause();
      }
      // 重新构建队列并继续播放，应用新的设置
      playCurrentWord();
    } else if (playQueue.value.length > 0) {
      // 如果之前有队列但暂停了，清除暂停状态和队列，下次播放时会重新构建
      playQueue.value = [];
      pausedTime.value = 0;
      currentAudioUrl.value = "";
      currentPlayIndex.value = 0;
    }
  }

  // 保存到 Android 本地，每个字段单独调用一次
  saveSettingsToAndroid(
    "wordTranslateStatus",
    newSettings.wordTranslateStatus ?? 1
  );
  saveSettingsToAndroid(
    "wordSyllablesStatus",
    newSettings.wordSyllablesStatus ?? 0 // 默认关闭
  );
  saveSettingsToAndroid(
    "wordExampleStatus",
    newSettings.wordExampleStatus ?? 1 // 默认开启
  );
  saveSettingsToAndroid("loopStatus", newSettings.loopStatus ?? 1); // 默认开启
  saveSettingsToAndroid("loopCount", newSettings.loopCount ?? 1);
};

// Token 相关变量
const token = ref("");

// 将文本中的 \n 转换为 <br>
// 同时处理真正的换行符（\n）和字符串形式的 \n
const formatText = (text) => {
  if (!text) return "";
  let result = String(text);
  // 先处理真正的换行符（一个字符）
  result = result.replace(/\n/g, "<br>");
  // 再处理字符串形式的 \n（两个字符：反斜杠和n）
  result = result.replace(/\\n/g, "<br>");
  return result;
};

// 检查指定位置前面是否有偶数个连续的反斜杠（包括0个）
function hasEvenBackslashes(str, index) {
  let count = 0;
  for (let i = index - 1; i >= 0 && str[i] === "\\"; i--) {
    count++;
  }
  return count % 2 === 0;
}

// 修复 JSON 字符串中的转义问题
// 如果 JSON.parse 失败，先尝试替换字符串中的 \n 等字符，然后再解析
function fixJsonEscape(jsonStr) {
  if (typeof jsonStr !== "string") {
    return jsonStr;
  }

  // 先尝试直接解析，如果成功则不需要修复
  try {
    JSON.parse(jsonStr);
    return jsonStr;
  } catch (e) {
    // 解析失败，尝试修复转义问题
    const errorPos = e.message.match(/position (\d+)/)?.[1];
    console.log(errorPos, "errorPos");
    // 方法1：先尝试替换真正的换行符、制表符等控制字符（在字符串值中）
    let fixedStr = jsonStr;

    // 替换字符串值中的真正的换行符、制表符等为转义序列
    // 使用正则匹配：在双引号内的换行符、制表符等
    fixedStr = fixedStr.replace(/"([^"\\]*(\\.[^"\\]*)*)"/g, (match) => {
      // 在字符串值中，将真正的换行符替换为 \n，制表符替换为 \t
      return match
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/\t/g, "\\t");
    });

    // 尝试解析修复后的字符串
    try {
      JSON.parse(fixedStr);
      return fixedStr;
    } catch (e1) {
      // 方法1失败，尝试方法2
    }

    // 方法2：如果字符串值中有未转义的 \n（两个字符），尝试转义它们
    // 逐字符处理，修复字符串值中的转义字符
    let result = "";
    let i = 0;
    let inString = false;

    while (i < jsonStr.length) {
      const char = jsonStr[i];
      const nextChar = i < jsonStr.length - 1 ? jsonStr[i + 1] : "";

      // 检查是否是未转义的双引号（前面有偶数个反斜杠）
      if (char === '"' && hasEvenBackslashes(jsonStr, i)) {
        inString = !inString;
        result += char;
        i++;
      } else if (char === "\\" && inString) {
        // 在字符串内遇到反斜杠
        if ('ntrbf"\\'.includes(nextChar)) {
          // 检查前面是否有偶数个反斜杠（即这是单个反斜杠，不是双反斜杠的一部分）
          if (hasEvenBackslashes(jsonStr, i)) {
            // 需要添加额外的反斜杠进行二次转义
            result += "\\\\" + nextChar;
            i += 2; // 跳过当前反斜杠和下一个字符
            continue;
          } else {
            // 前面有奇数个反斜杠，说明这是双反斜杠的一部分，保持不变
            result += char;
            i++;
          }
        } else {
          result += char;
          i++;
        }
      } else if (
        inString &&
        (char === "\n" || char === "\r" || char === "\t")
      ) {
        // 在字符串内遇到真正的换行符、回车符、制表符，转换为转义序列
        if (char === "\n") {
          result += "\\n";
        } else if (char === "\r") {
          result += "\\r";
        } else if (char === "\t") {
          result += "\\t";
        }
        i++;
      } else {
        result += char;
        i++;
      }
    }

    // 再次尝试解析
    try {
      JSON.parse(result);
      return result;
    } catch (e2) {
      // 返回原始字符串，让调用者处理错误
      return jsonStr;
    }
  }
}

// callJS 函数：处理原生调用（只处理页面特定的逻辑）
function callJS(data) {
  // 先解析数据
  let parsed;
  try {
    if (typeof data === "object" && data !== null) {
      parsed = data;
    } else {
      let jsonStr = typeof data === "string" ? data : JSON.stringify(data);
      try {
        parsed = JSON.parse(jsonStr);
      } catch (parseError) {
        // 尝试修复 JSON 转义问题
        jsonStr = fixJsonEscape(jsonStr);
        parsed = JSON.parse(jsonStr);
      }
    }
  } catch (error) {
    console.log(error, "error");
    return;
  }

  // 如果是 getToken 或 getPageUrl，全局 callJS 已经处理了，这里不重复处理
  if (parsed.func === "getToken" || parsed.func === "getPageUrl") {
    return;
  }

  // 处理页面特定的逻辑
  handleParsedData(parsed);
}

// 处理解析后的数据
function handleParsedData(parsed) {
  if (!parsed || typeof parsed !== "object") {
    return;
  }

  // getToken 和 getPageUrl 已在 publicPage 中处理并保存到 localStorage，这里不再处理

  if (parsed.func == "getListenMusicWordList") {
    if (Array.isArray(parsed.params)) {
      // 不再使用安卓数据回显，只提取 bookId 和总数
      const firstParam = parsed.params[0] || {};
      const newBookId = firstParam.bookId || "";
      // 从安卓数据中获取总数（可能是 total、count、totalCount 等字段）
      const newTotalCount =
        firstParam.total ||
        firstParam.count ||
        firstParam.totalCount ||
        parsed.params.length ||
        0;

      // 如果 bookId 发生变化，重置分页状态和播放列表
      if (newBookId && newBookId !== bookId.value) {
        // 清空播放列表，等待接口数据
        playlistWordList.value = [];
        selectedWordIndex.value = 0;
        pageDataPagination.value = {
          page: 1, // 从第1页开始加载
          pageSize: 10,
          hasNextPage: true,
        };
        isLoadingPageData.value = false;
        // 重置第一次加载标志，新的 bookId 需要重新显示 loading
        isFirstLoad.value = true;
      }

      bookId.value = newBookId;
      totalWordCount.value = newTotalCount;

      // 获取到 bookId 后，开始加载分页数据（接口数据会直接填充 playlistWordList）
      if (bookId.value) {
        loadPageData();
      }
    }
    return;
  }

  // 处理读取设置数据
  if (parsed.func == "getDecodeDataMMKV") {
    if (parsed.params && parsed.params.keyStr) {
      const key = parsed.params.keyStr;
      let value = parsed.params.valueStr;

      // 如果值是空字符串、null 或 undefined，说明没有保存过设置，使用默认值
      if (value === "" || value === null || value === undefined) {
        // 根据不同的 key 设置默认值
        if (key === "wordTranslateStatus") {
          settings.value.wordTranslateStatus = 1; // 默认开启
        } else if (key === "wordSyllablesStatus") {
          settings.value.wordSyllablesStatus = 0; // 默认关闭
        } else if (key === "wordExampleStatus") {
          settings.value.wordExampleStatus = 1; // 默认开启
        } else if (key === "loopStatus") {
          settings.value.loopStatus = 1; // 默认开启
        } else if (key === "loopCount") {
          settings.value.loopCount = 1; // 默认1次
        }
        return;
      }

      // 尝试将值转换为数字，如果失败则保持原样
      const numValue = Number(value);
      if (!isNaN(numValue) && String(numValue) === String(value)) {
        // 确保是纯数字字符串
        value = numValue;
      }

      // 根据 keyStr 更新对应的设置字段
      if (key === "wordTranslateStatus") {
        settings.value.wordTranslateStatus = value ?? 1;
      } else if (key === "wordSyllablesStatus") {
        settings.value.wordSyllablesStatus = value ?? 0; // 默认关闭
      } else if (key === "wordExampleStatus") {
        settings.value.wordExampleStatus = value ?? 1; // 默认开启
      } else if (key === "loopStatus") {
        settings.value.loopStatus = value ?? 1; // 默认开启
      } else if (key === "loopCount") {
        // 确保 loopCount 是有效的数字（1、2、3），否则默认为1
        const validCount = [1, 2, 3].includes(numValue) ? numValue : 1;
        settings.value.loopCount = validCount;
      }
    }
    return;
  }

  // 处理 actOnDestroy 事件
  if (parsed.func == "actOnDestroy") {
    // 收到销毁事件，关闭所有音频并清理资源
    console.log("🔄 收到 actOnDestroy 事件，开始清理所有资源...");

    // 停止音频播放
    if (audioPlayer.value) {
      try {
        audioPlayer.value.pause();
        audioPlayer.value.src = "";
        audioPlayer.value.load?.();
      } catch (e) {
        // ignore
      }
    }

    // 清理播放状态
    isPlaying.value = false;
    isPlayingQueue.value = false;
    playQueue.value = [];
    currentPlayIndex.value = 0;
    pausedTime.value = 0;
    currentAudioUrl.value = "";
    currentWordPlayCount.value = 0;
    activeSyllableIndex.value = -1;
    currentPlayingItemType.value = "";

    // 清理定时器
    if (nextWordTimer.value) {
      clearTimeout(nextWordTimer.value);
      nextWordTimer.value = null;
    }
    if (playStartTimer) {
      clearTimeout(playStartTimer);
      playStartTimer = null;
    }
    if (switchPlayTimer) {
      clearTimeout(switchPlayTimer);
      switchPlayTimer = null;
    }
    if (toastTimer.value) {
      clearTimeout(toastTimer.value);
      toastTimer.value = null;
    }

    // 清理列表和状态
    playlistWordList.value = [];
    selectedWordIndex.value = 0;
    currentWordIndex.value = 0;
    wordList.value = [];

    console.log("✅ 所有资源已清理完成");
    return;
  }
}

// 分页加载单词数据
const loadPageData = async ({ trigger } = {}) => {
  if (
    !bookId.value ||
    isLoadingPageData.value ||
    !pageDataPagination.value.hasNextPage
  ) {
    return;
  }

  const currentPage = pageDataPagination.value.page;

  // 如果是第一次加载（第一页），显示 loading toast
  if (isFirstLoad.value && currentPage === 1) {
    isInitialListLoading.value = true;
    showLoadingToast("加载单词列表中...");
  }

  isLoadingPageData.value = true;
  try {
    const response = await pageListenWords({
      bookId: bookId.value,
      page: currentPage,
      pageSize: pageDataPagination.value.pageSize,
    });

    //   code: response.code,
    //   currentPage: response.data?.currentPage,
    //   hasNextPage: response.data?.hasNextPage,
    //   listLength: response.data?.list?.length,
    // });

    if (response.code === 200 && response.data && response.data.list) {
      const newList = response.data.list;

      // 直接使用接口返回的完整数据，不进行合并
      const processedList = newList.map((item) => {
        // 将嵌套的 word 对象展开到顶层
        const wordData = item.word || {};
        return {
          // 保留接口返回的所有字段
          ...item,
          ...wordData,
          // 确保 wordId 在顶层
          wordId: wordData.wordId || item.wordId,
          // 保留原始的 word 对象（如果需要）
          word: wordData,
        };
      });

      // 如果是第一页（page === 1），替换整个列表；否则追加
      if (currentPage === 1) {
        playlistWordList.value = processedList;
        // 第一页加载完成后，选中第一个单词
        selectedWordIndex.value = 0;
        // 第一次加载完成，隐藏 loading toast
        if (isFirstLoad.value) {
          isFirstLoad.value = false;
          hideLoadingToast();
          isInitialListLoading.value = false;
          // 数据加载完成后，自动开始播放第一个单词
          nextTick(() => {
            if (playlistWordList.value.length > 0 && currentWord.value) {
              playCurrentWord();
            }
          });
        }
      } else {
        playlistWordList.value = [...playlistWordList.value, ...processedList];
        // 只要“加载中”是滚动触发显示的，任何一次请求完成都要关闭它（避免后台预加载导致一直不关）
        if (scrollLoadingToastShown.value && isLoadingToast.value) {
          hideLoadingToast();
          scrollLoadingToastShown.value = false;
        }
        // 只要“加载中”是 next 按钮触发显示的，也在加载完成后关闭
        if (nextBtnLoadingToastShown.value && isLoadingToast.value) {
          hideLoadingToast();
          nextBtnLoadingToastShown.value = false;
        }
      }

      // 更新分页信息
      pageDataPagination.value.hasNextPage = response.data.hasNextPage || false;

      // 更新页码：如果 API 返回了 currentPage，使用它 + 1；否则使用当前页码 + 1
      if (
        response.data.currentPage !== undefined &&
        response.data.currentPage !== null
      ) {
        // API 返回了 currentPage，使用它 + 1 作为下一页
        pageDataPagination.value.page = response.data.currentPage + 1;
      } else {
        // API 没有返回 currentPage，使用当前页码 + 1
        pageDataPagination.value.page = currentPage + 1;
      }

      // 更新 localStorage
      localStorage.setItem(
        "playlistWordList",
        JSON.stringify(playlistWordList.value)
      );

      // 重置加载状态，准备加载下一页
      isLoadingPageData.value = false;

      // 如果已经没有下一页了，且滚动触发过 loading，也要确保关闭
      if (
        !pageDataPagination.value.hasNextPage &&
        scrollLoadingToastShown.value &&
        isLoadingToast.value
      ) {
        hideLoadingToast();
        scrollLoadingToastShown.value = false;
      }
      // 如果 next 按钮触发过 loading，也要确保关闭
      if (
        !pageDataPagination.value.hasNextPage &&
        nextBtnLoadingToastShown.value &&
        isLoadingToast.value
      ) {
        hideLoadingToast();
        nextBtnLoadingToastShown.value = false;
      }

      // 同时保留两套逻辑：
      // - 用户滚动到底：触发加载并显示 toast（handlePlaylistScroll）
      // - 后台自动预加载：用于“从首位点上一首跳末尾/切换播放没数据”等
      if (
        autoPrefetchEnabled.value &&
        pageDataPagination.value.hasNextPage &&
        trigger !== "scroll"
      ) {
        setTimeout(() => {
          loadPageData({ trigger: "prefetch" });
        }, 120);
      }
    } else {
      // 接口返回错误
      const errorMsg = response.msg || "加载单词列表失败，请稍后重试";
      isLoadingPageData.value = false;
      // 隐藏 loading toast（如果正在显示）
      if (isLoadingToast.value) {
        hideLoadingToast();
      }
      scrollLoadingToastShown.value = false;
      nextBtnLoadingToastShown.value = false;
      isInitialListLoading.value = false;
      // 显示错误 toast
      showToast(errorMsg, 3000);
    }
  } catch (error) {
    // 接口异常
    const errorMsg = error.message || "网络错误，请检查网络连接后重试";
    isLoadingPageData.value = false;
    // 隐藏 loading toast（如果正在显示）
    if (isLoadingToast.value) {
      hideLoadingToast();
    }
    scrollLoadingToastShown.value = false;
    nextBtnLoadingToastShown.value = false;
    isInitialListLoading.value = false;
    // 显示错误 toast
    showToast(errorMsg, 3000);
  }
};

// 请求页面特定的数据
function goToken() {
  // 先调用全局 getToken（如果存在），确保 token 和 host 已获取
  if (window.getToken) {
    window.getToken();
  }

  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem("token");
  if (savedToken) {
    token.value = savedToken;
  }

  // 请求页面特定的数据
  const wordListRequest = JSON.stringify({
    func: "getListenMusicWordList",
  });
  if (window.android) {
    window.android.callNative(wordListRequest);
  }
}

onMounted(() => {
  // 保存原有的 callJS（全局的）
  const originalCallJS = window.callJS;
  window.callJS = (data) => {
    // 先调用全局 callJS（处理 getToken 和 getPageUrl）
    if (originalCallJS) {
      originalCallJS(data);
    }
    // 然后调用页面特定的 callJS（只处理页面特定的逻辑，getToken 和 getPageUrl 会被跳过）
    callJS(data);
  };

  // 打印页面视口大小
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  console.log("📐 页面视口大小:", {
    width: viewportWidth,
    height: viewportHeight,
    devicePixelRatio: window.devicePixelRatio || 1,
    screen: {
      width: window.screen.width,
      height: window.screen.height,
    },
  });

  // 从 localStorage 读取 token
  const savedToken = localStorage.getItem("token");
  if (savedToken) {
    token.value = savedToken;
  }

  // 从 Android 本地读取设置
  loadSettingsFromAndroid();

  // 请求页面特定的数据（会先调用全局 getToken）
  goToken();
});
</script>

<style scoped lang="scss">
.page {
  position: relative;
  width: 100%; // 继承父容器 #app 的 960px
  height: 100%; // 继承父容器 #app 的 600px
  padding: 48px 28px 0;
  box-sizing: border-box;
  background-color: transparent;

  // 使用伪元素创建固定背景，覆盖整个视口
  // 使用视口单位确保覆盖整个屏幕，不受 transform 影响
  &::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw; // 使用视口宽度，确保覆盖整个屏幕
    height: 100vh; // 使用视口高度，确保覆盖整个屏幕
    background: transparent;
    z-index: -1; // 确保背景在内容下方
    pointer-events: none; // 确保背景不阻挡交互
  }

  // 三段式喇叭图标（默认三张都显示；播放中 wave1/wave2 交替闪烁）
  .horn-anim {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 18px;

    img {
      display: block;
      // 完整展示图片，不裁切
      object-fit: contain;
      object-position: center;
      max-width: 100%;
      max-height: 100%;
    }

    .horn {
      width: 7px;
      height: 11px;
    }

    .wave {
      opacity: 1; // 默认三张都显示
    }
    .wave1 {
      width: 2.12px;
      height: 7.18px;
      margin-left: 1px;
    }
    .wave2 {
      width: 3px;
      height: 10.89px;
    }

    &.playing {
      .wave1 {
        opacity: 1;
        animation: hornWave1Frames 0.72s steps(1, end) infinite;
      }
      .wave2 {
        opacity: 0;
        animation: hornWave2Frames 0.72s steps(1, end) infinite;
      }
    }
  }

  &.player-view {
    // player-view 使用不同的背景图
    &::before {
      // background: url("@/assets/walkman/bg.png") no-repeat center center;
      // background-size: cover;
      background: transparent;
      width: 100vw; // 确保覆盖整个视口宽度
      height: 100vh; // 确保覆盖整个视口高度
    }
    border-radius: 0;
  }

  .header {
    position: relative;
    width: 960px; // 固定宽度，占满整个设计稿宽度（960px），缩放会自动处理
    margin-left: -28px; // 抵消 page 的 left padding，使 header 从页面左边缘开始
    padding: 0 28px; // 内容区域保持左右 padding
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333333;

    .ic-back {
      width: 15px;
      height: 25px;
      transition: opacity 0.3s;
    }
    .header-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-weight: bold;
      font-size: 18px;
    }
    .setting {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333333;
      font-size: 16px;
      img {
        width: 19px;
        height: 19px;
        margin-right: 5px;
      }
    }
  }

  // Player 视图背景
  .card:has(.player-container) {
    background: transparent;
  }

  .card {
    position: absolute;
    top: 48px; // 从 page 的 padding-top 开始
    // 调整间距和高度，让整体内容严格落在 600 设计高度内，避免在 1130x706 这类分辨率下被底部裁剪
    margin-top: 40px; // 原为 45px，向上收一点
    left: 28.5px; // (960 - 903) / 2 = 28.5px，直接使用固定值确保居中
    width: 903px;
    height: 508px; // 原为 512px，整体略微收缩，肉眼基本无差别
    background: url("@/assets/walkman/card-bg.png") no-repeat center center;
    background-size: cover;
    padding: 15px 15px 36px;
    box-sizing: border-box;

    .card-header {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #333333;
      span {
        color: #8456ff;
      }
    }

    .empty-state {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 36px; // 与 card-header 的间距

      img {
        width: 308px * 0.8;
        height: 286px * 0.8;
        object-fit: contain;
      }
    }
  }

  .word-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 39px;
    .word {
      position: relative;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 59px;
      color: #333333;
      line-height: 83px;
      height: 83px;
      font-family: PingFang SC, PingFang SC;
      margin-bottom: 2px;

      .word-text {
        white-space: pre-wrap;
      }

      .word-syllable {
        display: inline-block;
        border-radius: 8px;
        line-height: 1.1;
        transition: background-color 0.15s ease, color 0.15s ease,
          transform 0.15s ease;
        &.active {
          color: #ffffff;
          transform: translateY(-1px);
        }
      }

      .phonetic-symbols {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        right: -21px;
        transform: translate(100%, -50%);
        padding: 9px 10px;
        box-sizing: border-box;
        font-size: 11px;
        color: #666666;
        border-radius: 5px;
        border: 1px solid #c8c8c8;
        overflow: hidden;
        height: 34px;
      }
    }

    .split {
      display: flex;
      align-items: center;
      justify-content: center;
      /* margin-top: 5px; */
      .item {
        font-size: 15px;
        color: #666666; // 默认不高亮
        margin-right: 10px;
        padding: 10px 23px;
        box-sizing: border-box;
        background: #fff5be; // 默认背景
        border-radius: 5px;
        font-size: 14px;
        transition: background-color 0.15s ease, color 0.15s ease,
          transform 0.15s ease, font-weight 0.15s ease;
        &.active {
          font-weight: 700;
          transform: translateY(-1px);
        }
      }
    }

    .explain {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 12px auto 8px;
      font-weight: 500;
      font-size: 13px;
      color: #666666;
      line-height: 1.5;
      text-align: center;
    }

    .example {
      display: flex;
      align-items: center;
      justify-content: center;
      > span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 26px;
        border-radius: 5px;
        font-weight: 500;
        font-size: 13px;
        color: #8456ff;

        &:nth-child(1) {
          background: #ebe7ff;
        }
      }
      .example-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: #666666;
        margin: 30px 15px 0;
        span {
          font-weight: 500;
          font-size: 13px;
          color: #666666;
          text {
            color: #8456ff;
          }
          &:nth-child(2) {
            margin-top: 5px;
            color: #999999;
          }
        }
      }
      .horn-anim {
        margin-top: 5px;
      }
    }
  }

  .title {
    display: flex;
    align-items: center;

    .title-icon {
      width: 3px;
      height: 11px;
      background: #a07dff;
      border-radius: 2px;
    }

    .title-text {
      font-size: 14px;
      color: #333333;
      font-weight: 600;
      margin-left: 5px;
      span {
        color: #8456ff;
      }
    }
  }

  .ic-close {
    width: 15px;
    height: 15px;
  }

  .content {
    height: 390px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow-y: auto;
    position: relative;

    .content-item {
      position: relative;
      padding: 12px 0;
      transition: background-color 0.2s;

      &.active {
        .word-name {
          color: #8456ff;
        }

        .word-info {
          color: #8456ff;
        }
      }

      .word-name {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 2px;
      }

      .word-info {
        font-size: 13px;
        color: #999999;
      }

      .audio-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 26px;
          height: 10px;
        }
      }
    }

    .no-more-data {
      padding: 20px 0;
      text-align: center;
      font-size: 13px;
      color: #999999;
      user-select: none;
      -webkit-user-select: none;
    }
  }
}

// Player 视图样式
.player-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .record-player {
    position: relative;
    width: 332px;
    height: 270px;
    background: url("@/assets/walkman/player-box.png") no-repeat center center;
    background-size: cover;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 29px 0 0;

    .tonearm {
      position: absolute;
      top: 30px;
      right: 30px;
      width: 96px;
      height: 111px;
      z-index: 10;
      // transform-origin 使用像素值，便于精确调整
      // 默认值：96px 0px (对应 top right，即右上角)
      // 如果需要微调，可以调整这两个值：
      // - 第一个值（x轴）：增大向右移动原点，减小向左移动原点
      // - 第二个值（y轴）：增大向下移动原点，减小向上移动原点
      transform-origin: 82px 18px;
      transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
      transform: rotate(-50deg);
      background: url("@/assets/walkman/neddle.png") no-repeat center center;
      background-size: cover;
      &.playing {
        transform: rotate(0deg);
      }
    }

    .record-disc {
      width: 220px;
      height: 220px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.3);
      animation: rotateDisc 3s linear infinite;
      animation-play-state: paused;

      &.rotating {
        animation-play-state: running;
      }

      .album-cover {
        width: 110px;
        height: 81px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
          border-radius: 14px;
        }
      }
    }
  }

  .progress-indicator {
    font-size: 25px;
    color: #8456ff;
    margin: 14px;

    .total-count {
      color: #999;
      font-weight: 400;
    }
  }
}

// 唱片旋转动画
@keyframes rotateDisc {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// Toast 提示样式
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.75);
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  max-width: 80%;
  text-align: center;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &.show {
    opacity: 1;
    pointer-events: auto;
  }

  &.loading {
    padding: 16px 24px;
  }

  .loading-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

// 三帧动画：①wave1 ②wave1+wave2 ③都不显示（循环），停止后默认都显示
@keyframes hornWave1Frames {
  0% {
    opacity: 1;
  }
  33.333% {
    opacity: 1; // ①→② wave1 持续显示
  }
  66.666% {
    opacity: 0; // ③ wave1 关闭
  }
  100% {
    opacity: 1;
  }
}

@keyframes hornWave2Frames {
  0% {
    opacity: 0; // ① wave2 关闭
  }
  33.333% {
    opacity: 1; // ② wave2 打开
  }
  66.666% {
    opacity: 0; // ③ wave2 关闭
  }
  100% {
    opacity: 0;
  }
}
</style>
